import styled from "styled-components";

const StyledProblemBar = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0;
  button {
    flex: 1;
    padding: 10px;
    border-radius: 6px;
    background-color: rgba(86, 124, 251, 1);
    transition: 0.2s;
    &:hover {
      background-color: rgba(86, 124, 251, 0.9);
    }
    &[disabled] {
      pointer-events: none;
      background-color:rgb(194, 199, 210);
    }
    span {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: #fff;
    }
  }
`;

export default StyledProblemBar;
